import React from 'react';
import { Page, PageFormData, Template } from '../../types/cms';

interface PageEditorProps {
  page?: Page;
  onSave: (data: PageFormData) => Promise<void>;
  onCancel: () => void;
  templates: Template[];
  loading?: boolean;
}

const PageEditor: React.FC<PageEditorProps> = ({ 
  page, 
  onSave, 
  onCancel, 
  templates, 
  loading 
}) => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">
            {page?.id ? 'Edit Page' : 'Create New Page'}
          </h1>
          <p className="mt-1 text-sm text-gray-500">
            {page?.id ? 'Update your page content' : 'Create a new page with rich content'}
          </p>
        </div>
        <div className="flex space-x-3">
          <button onClick={onCancel} className="btn-secondary">
            Cancel
          </button>
          <button className="btn-primary" disabled={loading}>
            {loading ? 'Saving...' : 'Save Page'}
          </button>
        </div>
      </div>

      <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-200 text-center">
        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <span className="text-2xl">✏️</span>
        </div>
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          Rich Page Editor Coming Soon
        </h3>
        <p className="text-gray-500">
          Create and edit pages with a full WYSIWYG editor, SEO management, and template selection.
        </p>
      </div>
    </div>
  );
};

export default PageEditor;
